import { TextField } from '@atoms';
import { FC } from 'react';
import { SelectFabric } from '@molecules';
import { Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';
import {
  MONITORING_ASSET_MAPPER,
  MonitoringAssetStatusEnum,
  MONITORING_CATEGORY_MAPPER,
  MonitoringAssetCategoryEnum,
} from '../utils';

const AddMonitoringModalForm: FC<{ control: any }> = ({ control }) => {
  const statusOptions = Object.values(MonitoringAssetStatusEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value,
      label: MONITORING_ASSET_MAPPER[value as MonitoringAssetStatusEnum],
    }));

  const categoryOptions = Object.values(MonitoringAssetCategoryEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value,
      label: MONITORING_CATEGORY_MAPPER[value as MonitoringAssetCategoryEnum],
    }));

  return (
    <>
      <TextField
        name="title"
        label="Title"
        placeholder="Enter your title"
        control={control}
        sx={{ mb: '20px' }}
      />
      <TextField
        name="photoUrl"
        label="Photo Url"
        placeholder="Enter photo URL"
        control={control}
        sx={{ mb: '20px' }}
      />
      <SelectFabric
        name="status"
        label="Status"
        placeholder="Select a Status"
        control={control}
        options={statusOptions}
        sx={{ mb: '20px' }}
      />
      <SelectFabric
        name="category"
        label="Category"
        placeholder="Select a Category"
        control={control}
        options={categoryOptions}
        sx={{ mb: '20px' }}
      />
      <TextField
        name="priority"
        label="Priority"
        placeholder="Enter priority"
        control={control}
        type="number"
        required
        sx={{ mb: '20px' }}
      />
      <div>
        <Controller
          name="isTalent"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox checked={field.value} onChange={field.onChange} />}
              label="Is Talent"
            />
          )}
        />
      </div>
    </>
  );
};

export default AddMonitoringModalForm;
